<template>
  <div>
    <vue-data-table
      :headers="headers"
      :data="credits"
      :items-per-page="10"
      :buttons="buttons"
      :summable-columns="summableColumns"
      :table-actions="tableActions"
    >
      <!-- Supplier Reference -->
      <template #cell-reference="{ row }">
        <input
          type="checkbox"
          class="form-check-input me-2"
          :value="row.supplier_reference"
          v-model="selections"
        />
        {{ row.supplier_reference }}
      </template>

      <!-- Supplier Name -->
      <template #cell-supplierFullName="{ row }">
        <span v-if="row.supplier" class="fw-bold">
          {{ row.supplier.society }}
        </span>
      </template>

      <!-- Total Unpaid -->
      <template #cell-totalUnpaid="{ row }">
        <span class="badge bg-danger">
          {{ parseFloat(row.totalUnpaid).toFixed(2) | formatWithSpaces }}
        </span>
      </template>

      <!-- Credit Status -->
      <template #cell-creditStatus="{ row }">
        <div
          v-if="row.supplier && row.supplier.maxUnpaid > 0"
          class="d-flex align-items-center"
        >
          <input
            type="range"
            class="form-range"
            :min="0"
            :max="row.supplier.maxUnpaid"
            :value="row.totalUnpaid"
            disabled
            :class="{
              'is-invalid': row.totalUnpaid >= row.supplier.maxUnpaid,
            }"
            style="width: 150px"
          />
          <small class="ms-2">
            {{ parseFloat(row.totalUnpaid).toFixed(2) }} /
            {{ parseFloat(row.supplier.maxUnpaid).toFixed(2) }}
          </small>
          <span
            v-if="row.totalUnpaid > row.supplier.maxUnpaid"
            class="badge bg-danger ms-2"
          >
            +
            {{
              parseFloat(
                row.totalUnpaid - row.supplier.maxUnpaid
              ).toFixed(2) | formatWithSpaces
            }}
          </span>
        </div>
      </template>

      <!-- Total TTC -->
      <template #cell-totalTTC="{ row }">
        <span class="badge bg-primary">
          {{ parseFloat(row.totalTTC).toFixed(2) | formatWithSpaces }}
        </span>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      selections: [],
      headers: [
        { field: "reference", label: "Référence" },
        { field: "supplierFullName", label: "Nom Complet" },
        { field: "totalUnpaid", label: "Total Impayé", class: "text-end" },
        { field: "creditStatus", label: "État de crédit" },
        { field: "totalTTC", label: "Total TTC", class: "text-end" },
        { field: "firstDate", label: "Du" },
        { field: "lastDate", label: "Au" },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-eye",
          class: "btn-outline-primary",
          action: (row) => this.viewDetails(row),
        },
      ],
      summableColumns: ["totalUnpaid", "totalTTC"],
      tableActions: [
        {
          label: "Actualiser",
          icon: "bi bi-arrow-clockwise",
          class: "btn-secondary",
          action: () => this.refresh(),
        },
        {
          label: "Imprimer",
          icon: "bi bi-printer",
          class: "btn-secondary",
          action: () => this.print(),
        },
        {
          label: "Imprimer Sélectionné",
          icon: "bi bi-printer",
          class: "btn-secondary",
          action: () => this.printSelected(this.selections),
          disabled: () => this.selections.length === 0,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("credit", {
      credits: "getCreditsSuppliers",
    }),
  },
  mounted() {
    this.$store.dispatch("credit/fetchCreditsSuppliers");
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("credit/fetchCreditsSuppliers");
      this.selections = [];
    },
    async print() {
      await this.$store.dispatch("credit/printAll");
    },
    async printSelected(data) {
      await this.$store.dispatch("credit/printAllSelected", data);
    },
    viewDetails(row) {
      this.$router.push({
        name: "reports-suppliers-index",
        query: {
          supplier_reference: row.supplier_reference,
          startDate: row.firstDate,
          endDate: row.lastDate,
        },
      });
    },
  },
  filters: {
    formatWithSpaces(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style scoped>
.form-range.is-invalid {
  color: #dc3545;
}

.form-range.is-invalid::-webkit-slider-thumb {
  background: #dc3545;
}

.form-range.is-invalid::-moz-range-thumb {
  background: #dc3545;
}

.form-range.is-invalid::-ms-thumb {
  background: #dc3545;
}
</style>
